import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Typography,
  Box,
  CircularProgress,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import type { GrafanaAlert } from '../api/types';

const STATE_COLORS: Record<string, string> = {
  firing: '#FF462D',
  pending: '#FFCB47',
  inactive: '#4CDD84',
  normal: '#4CDD84',
  nodata: '#9E9287',
  error: '#FF462D',
};

const useStyles = makeStyles(theme => ({
  chip: {
    fontWeight: 600,
    fontSize: 11,
    height: 22,
  },
  table: {
    '& td, & th': {
      padding: theme.spacing(0.75, 1.5),
      fontSize: 13,
    },
  },
  empty: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

interface Props {
  alerts: GrafanaAlert[];
  loading: boolean;
}

export const AlertsPanel = ({ alerts, loading }: Props) => {
  const classes = useStyles();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (!alerts.length) {
    return (
      <Typography className={classes.empty} variant="body2">
        No alerts configured for this entity
      </Typography>
    );
  }

  return (
    <Table size="small" className={classes.table}>
      <TableHead>
        <TableRow>
          <TableCell>Alert</TableCell>
          <TableCell>State</TableCell>
          <TableCell>Last Evaluated</TableCell>
          <TableCell>Summary</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {alerts.map(a => (
          <TableRow key={a.name}>
            <TableCell>{a.name}</TableCell>
            <TableCell>
              <Chip
                className={classes.chip}
                label={a.state}
                style={{
                  backgroundColor: STATE_COLORS[a.state] ?? '#9E9287',
                  color: '#fff',
                }}
                size="small"
              />
            </TableCell>
            <TableCell>
              {a.lastEvaluation
                ? new Date(a.lastEvaluation).toLocaleTimeString()
                : '—'}
            </TableCell>
            <TableCell>
              {a.annotations?.summary ?? a.annotations?.description ?? '—'}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
